export class User {
    idNo: number;
    epfNo: string;
    mobileNo: number;
    email: string;
  }
  